import React from "react";
import { mdiPencil } from "@mdi/js";
import MdiIcon from "../../components/device/app/MdiIcon";

// A row card as in the app's Universal Remotes and Select Device
// (app/screens/HashhRemote/RemoteListingScreen.js and RemoteCard.js): an icon
// in a circle, the name, a line in the accent colour (a remote's brand or a
// blaster's device id) and floor | room. With onEdit it gets the app's
// round edit button. Render it inside a <ul className="hx-remote-cards">.
const RemoteCard = ({ icon, name, accent, meta, onOpen, onEdit, editLabel }) => (
  <li className="hx-remote-card">
    <button type="button" className="hx-remote-card-open" onClick={onOpen}>
      <span className="hx-remote-card-icon" aria-hidden="true">
        <MdiIcon path={icon} size={30} />
      </span>
      <span className="hx-remote-card-text">
        <span className="hx-remote-card-name">{name}</span>
        {accent ? <span className="hx-remote-card-accent">{accent}</span> : null}
        {meta ? <span className="hx-remote-card-meta">{meta}</span> : null}
      </span>
    </button>
    {onEdit ? (
      <button type="button" className="hx-remote-card-edit" onClick={onEdit} aria-label={editLabel}>
        <MdiIcon path={mdiPencil} size={16} />
      </button>
    ) : null}
  </li>
);

export default RemoteCard;
